import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { I18nProvider } from './i18n/I18nContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Dashboard } from './pages/Dashboard';
import { JourneyPage } from './pages/JourneyPage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { MissionPage } from './pages/MissionPage';
import { AccountPage } from './pages/AccountPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { FAQPage } from './pages/FAQPage';
import { MagicLinkVerifyPage } from './pages/MagicLinkVerifyPage';
import { EditModeProvider } from './components/EditMode';
import { EditModeFab } from './components/EditModeFab';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
      <EditModeProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/journey" element={<JourneyPage />} />
          <Route path="/mission" element={<MissionPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/faq" element={<FAQPage />} />

          {/* Auth */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/auth/magic-link" element={<MagicLinkVerifyPage />} />

          {/* Legacy redirects */}
          <Route path="/admin/login" element={<Navigate to="/login" replace />} />
          <Route path="/pledge" element={<Navigate to="/signup" replace />} />
          <Route path="/supporter/dashboard" element={<Navigate to="/account" replace />} />

          {/* Admin (protected) */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute requireRole="admin">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        <EditModeFab />
      </BrowserRouter>
      <Toaster />
      </EditModeProvider>
    </AuthProvider>
    </I18nProvider>
  );
}

export default App;
